import { cloneDeep } from 'lodash';
import { AbstractEntity } from "../AbstractEntity";
import Signature from "../Signature";
import { User } from "../usercontrol";
import { getUtcNow } from "../../utils";
export default class EquipmentItem extends AbstractEntity {
    static prepareEdit(equipmentItem, author) {
        const newVersion = new EquipmentItem({
            name: equipmentItem.name,
            list: equipmentItem.list,
            author: User.createRef(author._id),
        });
        newVersion.itemData = cloneDeep(equipmentItem.itemData);
        newVersion.contentTypeConfig = cloneDeep(equipmentItem.contentTypeConfig);
        newVersion.predecessor = EquipmentItem.createRef(equipmentItem._id);
        return newVersion;
    }
    createdTimestamp;
    author;
    list;
    name;
    itemData;
    contentTypeConfig;
    predecessor;
    deleted;
    signature;
    constructor(equipmentItem = {}) {
        super();
        Object.assign(this, { createdTimestamp: getUtcNow(), itemData: {}, contentTypeConfig: [] }, equipmentItem);
    }
}
//# sourceMappingURL=EquipmentItem.js.map